<template>
  <div class="page-newsletter tier tier-three">
    <div class="tier-content">
      <Tooltip content="Here are the settings for your Mailchimp settings"/>

      <Notification
        v-if="notification.active"
        :content="notification.content"
        :type="notification.type"/>

      <PageHeader>
        <div class="heading">
          <h1>
            Mailchimp Settings
          </h1>
        </div>
        <Btn secondary @click="activateConfirm">
          <Sprite name="bin"/>
        </Btn>
      </PageHeader>

      <div class="site-newsletter">
        <mailchimp-form v-model="newsletter" @submit="submitNewsletter"></mailchimp-form>
      </div>

      <router-view/>

      <Confirm
        v-if="confirmActive"
        @confirm="deleteNewsletter"
        @cancel="cancel"
        :message="deleteMessage"
        :link="{
          name: 'newsletter-settings',
          params: {companyId: this.companyId, siteId: this.siteId}}"/>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'
import notification from '@/mixins/notification'
import confirm from '@/mixins/confirm'

import {readCompanySiteData} from '@/lib/sites'
import {readCompanySiteMailchimpData, deleteCompanySiteMailchimpData, updateCompanySiteMailchimpData} from '@/lib/mailchimps'

import MailchimpForm from '@/components/forms/MailchimpForm'
import PageHeader from '@/components/PageHeader'
import Btn from '@/components/Btn'
import Sprite from '@/components/Sprite'
import Tooltip from '@/components/Tooltip'

export default {
  name: 'Newsletter',

  props: {
    companyId: {
      type: String,
      required: true
    },

    siteId: {
      type: String,
      required: true
    }
  },

  mixins: [page, pagination, confirm, notification],

  components: {
    PageHeader,
    Btn,
    Sprite,
    Tooltip,
    MailchimpForm
  },

  data() {
    return {
      site: {},
      newsletter: {},
      errors: {}
    }
  },

  methods: {
    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(
        ({data}) => {
          this.site = data
        }
      )

      readCompanySiteMailchimpData(this.companyId, this.siteId).then(
        ({data}) => {
          this.newsletter = data
        }
      )
    },

    submitNewsletter() {
      updateCompanySiteMailchimpData(
        this.companyId,
        this.siteId,
        this.newsletter
      ).then(({data}) => {
        this.$emit('updatePage')
        this.triggerNotification('success', 'Newsletter settings', 'updated')
      })
    },

    deleteNewsletter() {
      deleteCompanySiteMailchimpData(this.companyId, this.siteId).then(
        () => {
          this.$emit('updatePage')
          this.confirmActive = false
          this.triggerNotification('success', 'Mailchimp', 'removed')

          window.setTimeout(() => {
            this.$router.push({
              name: 'newsletter-settings',
              params: {companyId: this.companyId, siteId: this.siteId}
            })
          }, this.closeDelay)
        }
      )
    }
  },

  computed: {
    title() {
      return `Editing Newsletter`
    },

    deleteMessage() {
      return `Are you sure you wish to disconnect the newsletter?`
    },

    updatedNotification() {
      return {
        type: 'success',
        content: `Mailchimp settings updated!`
      }
    },

    deletedNotification() {
      return {
        type: 'success',
        content: `Mailchimp list disconnected!`
      }
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-page

.table-heading
  display: flex
  align-items: center
  justify-content: space-between
  position: relative

  .btn
    padding: 3px 5px

.image-preview
  max-width: 300px
</style>
